/* © NXAPP Limited */
import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(d: string | Date) {
  return new Date(d).toLocaleDateString('en-GB', {
    day: 'numeric', month: 'short', year: 'numeric',
  })
}

export function formatDateTime(d: string | Date) {
  return new Date(d).toLocaleString('en-GB', {
    day: 'numeric', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  })
}

export function pct(num: number, denom: number) {
  if (!denom) return '0%'
  return `${Math.round((num / denom) * 100)}%`
}

/** Returns the coming Friday at 09:00 UTC */
export function nextFriday(): Date {
  const d = new Date()
  const day = d.getUTCDay()          // 0=Sun … 6=Sat
  const daysUntilFriday = (5 - day + 7) % 7 || 7
  d.setUTCDate(d.getUTCDate() + daysUntilFriday)
  d.setUTCHours(9, 0, 0, 0)
  return d
}
